/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamDataPlatforms
 */
export interface OWGameSteamDataPlatforms {
    /**
     * 
     * @type {boolean}
     * @memberof OWGameSteamDataPlatforms
     */
    windows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OWGameSteamDataPlatforms
     */
    mac?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OWGameSteamDataPlatforms
     */
    linux?: boolean;
}

export function OWGameSteamDataPlatformsFromJSON(json: any): OWGameSteamDataPlatforms {
    return OWGameSteamDataPlatformsFromJSONTyped(json, false);
}

export function OWGameSteamDataPlatformsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamDataPlatforms {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'windows': !exists(json, 'windows') ? undefined : json['windows'],
        'mac': !exists(json, 'mac') ? undefined : json['mac'],
        'linux': !exists(json, 'linux') ? undefined : json['linux'],
    };
}

export function OWGameSteamDataPlatformsToJSON(value?: OWGameSteamDataPlatforms | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'windows': value.windows,
        'mac': value.mac,
        'linux': value.linux,
    };
}


